import React, { useState } from "react";
import SwitchIcon from "src/assets/images/switch.svg";

interface QuantInsightsPanelProps {
    json_response: any;
}

const TAG_COLORS: Record<string, string> = {
    DRIVER: "bg-green-100 text-green-700 border-green-300",
    SUMMARY: "bg-blue-100 text-blue-700 border-blue-300",
    BARRIER: "bg-red-100 text-red-700 border-red-300",
    CONTEXT: "bg-purple-100 text-purple-700 border-purple-300",
};

const QuantInsightsPanel = ({ json_response }: QuantInsightsPanelProps) => {
    const [open, setOpen] = useState(true);

    const { insights = [], opportunity_zones = [] } = json_response || {};

    return (
        <div
            className={`
        h-screen
        overflow-hidden
        transition-all duration-300 ease-in-out
        bg-white rounded-lg shadow-sm
        ${open ? "w-[420px] sm:w-[380px] xs:w-full" : "w-[75px]"}
      `}
        >
            <div className="flex flex-col h-full">

                {/* HEADER */}
                <div className="flex items-center justify-between mb-4 p-3 border-b">
                    <h2 className="text-lg font-semibold whitespace-nowrap overflow-hidden">
                        {open ? "Insights" : ""}
                    </h2>
                    <button
                        onClick={() => setOpen(!open)}
                        className="cursor-pointer rounded border border-[#DFE3E8] p-1 hover:bg-gray-100"
                    >
                        <img src={SwitchIcon} alt="toggle" className="w-3 h-3 object-contain" />
                    </button>
                </div>

                {/* BODY SCROLLER */}
                <div className="flex-1 overflow-y-auto p-3 space-y-6">

                    {/* INSIGHT CARDS */}
                    <div>
                        <h3 className="font-medium text-sm mb-2">Insight Cards</h3>

                        {insights.map((ins: any) => (
                            <div
                                key={ins.id}
                                className={`
                border rounded-lg p-3 mb-3 transition
                ${ins.is_hidden ? "opacity-50 bg-gray-100" : "bg-gray-50"}
              `}
                            >
                                <div className="flex justify-between items-start">
                                    <p className="font-semibold text-gray-800">{ins.headline}</p>

                                </div>

                                {/* STATS */}
                                {ins.stats && (
                                    <p className="text-sm text-gray-600 mt-1">{ins.stats}</p>
                                )}

                                {/* IMPLICATIONS */}
                                <p className="text-sm text-gray-700 mt-2">
                                    {ins.implications}
                                </p>

                                {/* TAGS */}
                                <div className="flex flex-wrap gap-2 mt-3">
                                    {ins.tags?.map((tag: string, idx: number) => (
                                        <span
                                            key={idx}
                                            className={`text-xs px-2 py-1 rounded border ${TAG_COLORS[tag] || "bg-gray-100 text-gray-600 border-gray-300"}`}
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* OPPORTUNITY ZONES */}
                    <div>
                        <h3 className="font-medium text-sm mb-2">Opportunity Zones</h3>

                        {opportunity_zones.map((op: any, i: number) => (
                            <div
                                key={i}
                                className="border rounded-lg p-3 mb-3 bg-blue-50"
                            >
                                <p className="font-semibold text-gray-800">{op.title}</p>
                                <p className="text-sm text-gray-700 mt-1">
                                    {op.potential_impact}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default QuantInsightsPanel;
